import api from '@/api/parish'
import {
  PARISH_SET_LIST,
  PARISH_SET_PARISH,
  PARISH_SET_CURRENT,
  PARISH_SET_BLOCK_IMAGE,
  PARISH_SET_PARISHIONERS,
  PARISH_TOGGLE_PARISHIONERS_DETAILS,
  PARISH_SET_DONATION_TYPES,
  PARISH_SET_DONATION_TYPE,
  PARISH_SET_BLOCK_TITLE,
  PARISH_DEL_DONATION_TYPE,
  PARISH_SET_DONATIONS,
  PARISH_ADD_DONATION,
  PARISH_SET_ALL_DONATIONS,
  PARISH_SET_DEFAULT_CURRENCY,
  PARISH_SET_AVAILABLE_CURRENCIES, PARISH_CLEAR
} from './mutations'

export default {
  clear: async ({ commit }) => {
    commit(PARISH_CLEAR)
  },
  loadParishesList: async ({ commit, state, getters, dispatch }, change) => {
    change = change || false
    try {
      const { parishes, origin } = await api.loadParishesList()
      commit(PARISH_SET_LIST, parishes)

      if (change || !getters.currentParish) {
        const storage = sessionStorage.getItem('active-parish')
        if (storage && state.parishes[storage]) {
          commit(PARISH_SET_CURRENT, storage)
        } else {
          commit(PARISH_SET_CURRENT, origin)
        }
      }

      if (Object.values(parishes).length > 0) {
        await dispatch('ChatModule/loadRoomsList', getters.currentParish, { root: true })
        await dispatch('ConferenceModule/loadRoomsList', getters.currentParish, { root: true })
      }
    } catch (error) {
      throw new Error(error.message)
    }
  },
  async prepareDonationsInvoice ({ getters }, donations) {
    try {
      return await api.prepareDonationsInvoice(getters.currentParish, donations)
    } catch (e) {
      throw new Error(e)
    }
  },
  changeCurrentParish: ({ commit }, parishId) => {
    commit(PARISH_SET_CURRENT, parishId)
  },
  async setParishBlockConfig ({ commit }, { parish, block, title, image }) {
    try {
      await api.setParishBlockConfig(parish, block, title, image)
      commit(PARISH_SET_BLOCK_IMAGE, { parish, block, image })
      commit(PARISH_SET_BLOCK_TITLE, { parish, block, title })
      commit(PARISH_SET_CURRENT, parish.id)
    } catch (error) {
      throw new Error(error.message)
    }
  },
  async loadParishionersList ({ commit }, { parish }) {
    try {
      const { parishioners } = await api.loadParishionersList(parish)
      commit(PARISH_SET_PARISHIONERS, { parish, parishioners })
    } catch (error) {
      throw new Error(error.message)
    }
  },
  toggleParishionerDetails ({ commit }, parishioner) {
    commit(PARISH_TOGGLE_PARISHIONERS_DETAILS, parishioner)
  },
  async saveParishInfo ({ commit }, parish) {
    try {
      const result = await api.saveParishInfo(parish)
      commit(PARISH_SET_PARISH, result.parish)
      commit(PARISH_SET_CURRENT, null)
      commit(PARISH_SET_CURRENT, parish.id)
      return { message: result.message }
    } catch (error) {
      throw new Error(error.message)
    }
  },
  async loadDonationTypes ({ commit }, { parish }) {
    try {
      const { donationTypes } = await api.loadDonationTypes(parish)
      commit(PARISH_SET_DONATION_TYPES, { parish, donationTypes })
    } catch (error) {
      throw new Error(error.message)
    }
  },
  async saveDonationType ({ commit }, { parish, donationType }) {
    try {
      const result = await api.saveDonationType(parish, donationType)
      commit(PARISH_SET_DONATION_TYPE, { parish, donationType: result.donationType })
      return result.donationType
    } catch (error) {
      throw new Error(error.message)
    }
  },
  async removeDonationType ({ commit }, { parish, donationType }) {
    try {
      await api.removeDonationType(parish, donationType)
      commit(PARISH_DEL_DONATION_TYPE, { parish, donationType })
    } catch (e) {
      throw new Error(e)
    }
  },
  async loadDonations ({ commit }, { parish, donationType }) {
    try {
      const { donations } = await api.loadDonations(parish, donationType)
      commit(PARISH_SET_DONATIONS, { donationType, donations })
    } catch (e) {
      throw new Error(e)
    }
  },
  async loadAllDonations ({ commit, getters }, parish) {
    parish = parish || getters.currentParish
    try {
      const { donations } = await api.loadAllDonations(parish)
      commit(PARISH_SET_ALL_DONATIONS, donations)
    } catch (e) {
      throw new Error(e)
    }
  },
  async saveDonation ({ commit }, { parish, donationType, donation }) {
    try {
      const result = await api.saveDonation(parish, donationType, donation)
      commit(PARISH_ADD_DONATION, { donationType, donation: result.donation })

      return result
    } catch (e) {
      throw new Error(e)
    }
  },
  async saveCurrenciesList ({ commit }, { parish, currency, currencies }) {
    try {
      await api.saveCurrenciesList(parish, currency, currencies)
      commit(PARISH_SET_DEFAULT_CURRENCY, { parish, currency })
      commit(PARISH_SET_AVAILABLE_CURRENCIES, { parish, currencies })
    } catch (e) {
      throw new Error(e)
    }
  },
  async loadPaymentFields ({ commit }, { invoice, service }) {
    try {
      return await api.loadPaymentFields(invoice, service)
    } catch (e) {
      throw new Error(e)
    }
  },
  async checkInvoice ({ commit }, invoiceId) {
    try {
      console.log(api)
      console.log(api.checkInvoice)
      const { invoice } = await api.checkInvoice(invoiceId)

      return invoice['paid_at'] !== null
    } catch (e) {
      throw new Error(e)
    }
  }
}
